import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface LegalLayoutProps {
  title: string;
  lastUpdated?: string;
  children: React.ReactNode;
}

const LegalLayout: React.FC<LegalLayoutProps> = ({ title, lastUpdated, children }) => {
  return (
    <div className="App">
      <Header />
      <main>
        <div className="legal-page">
          <div className="container legal-container">
            <h1>{title}</h1>
            {lastUpdated && <p className="legal-updated">Last updated: {lastUpdated}</p>}
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalLayout;
